import CurrencyContainer from "components/currency/CurrencyContainer";

export default function Currency() {
  return <CurrencyContainer />;
}
